/*
 * store details and featured link bar Constants
 * 
 * 
 * 
 * 
 
 * 
 * 
 */

export const EXPERIENCE_OUR_STORES = 'Experience Our Stores';
export const EXP_OUR_PRODUCTS = 'Experience our products at';
export const KM_AWAY = 'km away)';
export const INDIAS_HIGHEST =  "India's highest rated furniture app";
export const INSTALL = 'Install';
export const OUR_STORES = 'Our Stores';



